export class ClaseGenericaDTO {
    [key: string]: string;
}